import {
    convertCurrencyFormatPositiveNegative,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoGridOneColumn,
    showErrorMessage,
    RaikoTableTitleContainer,
    RaikoMaterialOutlinedInput,
    RaikoGridFourColumn,
    showWarningMessage,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoDatePicker,
    RaikoMoneyInputOutlined,
    convertPersianDateToUniversalDate,
    convertUniversalDateTimeToPersianDateTime,
    RaikoToggleOutlined,
    showSuccessMessage,
    RaikoMultiSelectTable, RaikoErrorSection, RaikoFlexFirstChildGrowOne, RaikoFlexAlignEnd,
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {css} from "@emotion/css";
import {RaikoStepper} from "../../raikoComponents/raikoStepper/RaikoStepper";
import {useAuthState} from "../../context/AuthContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {AccountService} from "../../serverService/account/AccountService";
import {useDebounce} from "@uidotdev/usehooks";
import RaikoCardInfoTypeOne, {
    RaikoCardInfoTypeOneItemGenerator,
} from "../../raikoComponents/raikoCardInfo/RaikoCardInfoTypeOne";
import {LoanService} from "../../serverService/loan/LoanService";
import {numberIsEmpty, stringIsEmpty} from "../../util/VariableChecker";
import {Skeleton} from "@mui/material";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";

export default function LoanCreateNew() {

    const {fundID} = useAuthState()

    const navigate = new useNavigate()

    const [stepper, setStepper] = useState(0)
    const [steps, setSteps] = useState(["مالک حساب", "اطلاعات وام", "ثبت وام"]);

    let page = 0
    const size = 15

    const [pageCount, setPageCount] = useState(0);
    const [usersList, setUsersList] = useState([]);
    const [totalItems, setTotalItems] = useState(0);

    const [selectedUser, setSelectedUser] = useState([]);
    const [selectedUserInfo, setSelectedUserInfo] = useState({})
    const [usersTableLoading, setUsersTableLoading] = useState(false);

    const [accountOwnerFullName, setAccountOwnerFullName] = useState("")
    const [accountNationalCode, setAccountNationalCode] = useState("")
    const [accountGroupName, setAccountGroupName] = useState("")
    const [accountCode, setAccountCode] = useState("");

    const filterAccountFullName = useDebounce(accountOwnerFullName, 300)
    const filterAccountNationalCode = useDebounce(accountNationalCode, 300)
    const filterAccountGroupName = useDebounce(accountGroupName, 300)
    const filterAccountCode = useDebounce(accountCode, 300)


    const [loanKinds, setLoanKinds] = useState([]);

    const userService = new AccountService()
    const loanService = new LoanService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        getLoanKinds()
    }, [fundID])


    useEffect(() => {
        getUsersFromServer()
    }, [
        fundID,
        filterAccountFullName,
        filterAccountNationalCode,
        filterAccountGroupName,
        filterAccountCode,
    ]);

    useEffect(() => {
        if (selectedUser && selectedUser.length > 0) {
            const _user = selectedUser[0]
            usersList.map((item, index) => {
                if (parseInt(item.id) === parseInt(_user.id)) {
                    setSelectedUserInfo(item)
                }
            })
        }
    }, [selectedUser]);

    function getLoanKinds() {
        loanService.getLoanKinds()
            .then(response => {
                setLoanKinds([])
                response.map((item, index) => {
                    setLoanKinds(prev => [
                        ...prev,
                        raikoCustomSelectItemGenerator(item.id, item.persianName)
                    ])
                })
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        })
    }

    function handleChangePage(newPage) {
        page = newPage
        getUsersFromServer()
    }

    function getUsersFromServer() {
        setUsersTableLoading(true)
        userService.getAccounts(
            page,
            size,
            fundID,
            filterAccountGroupName,
            filterAccountFullName,
            filterAccountNationalCode,
            filterAccountCode
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setUsersList([])
            response.data.map((item, index) => {
                setUsersList(prevState => [
                    ...prevState,
                    prepareItem(
                        item.id,
                        (page * size) + index + 1,
                        item.number,
                        item.ownerFirstName,
                        item.ownerLastName,
                        item.ownerNationalCode,
                        item.OwnerGroupName,
                        item.balance,
                        item.enabled,
                        item.cleared
                    )
                ])
            })


        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setUsersTableLoading(false)
        })
    }

    function prepareItem(id, number, accountCode, firstname, lastname, nationalCode, groupName, balance, enabled, cleared) {

        return {
            id,
            number,
            name: `${firstname} ${lastname}`,
            nationalCode: nationalCode ? nationalCode : '-',
            accountCode,
            group: groupName ? groupName : '-',
            capacity: convertCurrencyFormatPositiveNegative(balance),
            enabled: <RaikoCustomSimpleActiveDeActiveChip
                state={!cleared}
                deActiveStateTitle={"بسته شده"}
                activeStateTitle={"فعال"}
            />
        }
    }


    const [selectedLoanType, setSelectedLoanType] = useState("")
    const [loanAmount, setLoanAmount] = useState("");
    const [payDate, setPayDate] = useState("");
    const [installmentAmounts, setInstallmentAmounts] = useState("");

    const filterSelectedLoanType = useDebounce(selectedLoanType, 300)
    const filterLoanAmount = useDebounce(loanAmount, 500)
    const filterLoanPayDate = useDebounce(payDate, 500)
    const filterInstallmentAmounts = useDebounce(installmentAmounts, 500)

    const [installments, setInstallments] = useState([]);
    const [installmentsLoading, setInstallmentsLoading] = useState(false)

    useEffect(() => {
        if (
            filterSelectedLoanType.toString().length > 0 &&
            !numberIsEmpty(filterLoanAmount) &&
            !numberIsEmpty(filterInstallmentAmounts) &&
            !stringIsEmpty(filterLoanPayDate)
        ) {
            calculateLoanInstallments()
        } else
            setInstallments([])
    }, [
        filterSelectedLoanType,
        filterLoanAmount,
        filterLoanPayDate,
        filterInstallmentAmounts
    ]);

    function calculateLoanInstallments() {
        setInstallmentsLoading(true)
        loanService.calculateLoanInstallments(
            fundID,
            selectedUserInfo.id,
            filterLoanAmount,
            filterInstallmentAmounts,
            filterSelectedLoanType,
            convertPersianDateToUniversalDate(filterLoanPayDate)
        )
            .then(response => {
                setInstallments(response.installments)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setInstallmentsLoading(false)
        })
    }

    const [submitPaidForAll, setSubmitPaidForAll] = useState(false);

    function handleCreateNewLoan() {
        loading.show()
        loanService.createNewLoan(fundID, selectedUserInfo.id, loanAmount, installmentAmounts, selectedLoanType, convertPersianDateToUniversalDate(payDate), submitPaidForAll)
            .then(response => {
                showSuccessMessage("وام جدید با موفقیت ساخته شد.")
                handleClearFields()
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleClearFields() {
        setLoanAmount("")
        setPayDate("")
        setInstallmentAmounts("")
        setSelectedLoanType("")
        setInstallments([])
        setSelectedUser([])

        if (page !== 0) {
            page = 0
            getUsersFromServer()
        }

        setAccountOwnerFullName("")
        setAccountCode("")
        setAccountNationalCode("")
        setAccountGroupName("")

        setSubmitPaidForAll(false)

        setStepper(0)
    }

    function detectLoanKindName(id) {
        let _name = ""
        loanKinds.map((item) => {
            if (parseInt(item.id) === parseInt(id))
                _name = item.name
        })


        return _name
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>

                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb className={css`flex-grow: 1;
                      gap: .5rem;`} breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.LoansList.name,
                            RouteHelper.LoansList.globalUrl
                        ),
                        raikoBreadCrumbItemGenerator(
                            "ثبت وام جدید",
                            ""
                        )
                    ]}/>

                    <RaikoButtonSecondary
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(-1);
                        }}
                    />
                </RaikoFlexFirstChildGrowOne>


                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>

                        <RaikoFlexAlignEnd>
                            {
                                stepper !== 0 &&
                                <RaikoButtonSecondary
                                    label={stepper === 1 ? "تغییر حساب" : "تصحیح وام"}
                                    onClick={_ => {
                                        setStepper(prev => prev - 1)
                                    }}
                                />
                            }

                            {
                                stepper !== 2 ?
                                    <RaikoButtonPrimary
                                        label={stepper <= 1 ? "بعدی" : "ثبت وام"}
                                        onClick={_ => {
                                            if (stepper === 0) {
                                                if (selectedUser.length === 0) {
                                                    showWarningMessage("لطفا ابتدا حساب مورد نظر را انتخاب نمایید.")
                                                } else
                                                    setStepper(1)
                                            } else if (stepper === 1) {
                                                if (
                                                    filterSelectedLoanType.toString().length > 0 &&
                                                    !numberIsEmpty(filterLoanAmount) &&
                                                    !numberIsEmpty(filterInstallmentAmounts) &&
                                                    !stringIsEmpty(filterLoanPayDate)
                                                ) {
                                                    setStepper(prev => prev + 1)
                                                } else {
                                                    showWarningMessage("لطفا اطلاعات وام را به درستی وارد نمایید.")
                                                }
                                            }
                                        }}
                                    /> : ""
                            }
                        </RaikoFlexAlignEnd>

                        <div
                            className={css`
                              display: grid;
                              gap: 1.5rem;
                              position: relative;
                            `}
                        >

                            <RaikoGridOneColumn
                                className={css`
                                  gap: 1.5rem;
                                `}
                            >
                                <div>
                                    <RaikoStepper
                                        activeStep={stepper}
                                        steps={steps}
                                        alternativeLabel={true}
                                        orientation={"horizontal"}
                                    />
                                </div>
                                {
                                    stepper === 0 ?
                                        <RaikoGridOneColumn>

                                            <RaikoTableTitleContainer
                                                title={"حساب ها"}
                                                amount={totalItems}
                                            />

                                            <RaikoGridFourColumn>
                                                <RaikoMaterialOutlinedInput
                                                    labelText={"نام و نام خانوادگی"}
                                                    value={accountOwnerFullName}
                                                    setValue={setAccountOwnerFullName}

                                                />
                                                <RaikoMaterialOutlinedInput
                                                    labelText={"کد ملی"}
                                                    value={accountNationalCode}
                                                    setValue={setAccountNationalCode}

                                                />
                                                <RaikoMaterialOutlinedInput
                                                    labelText={"نام گروه"}
                                                    value={accountGroupName}
                                                    setValue={setAccountGroupName}

                                                />
                                                <RaikoMaterialOutlinedInput
                                                    labelText={"شناسه حساب"}
                                                    value={accountCode}
                                                    setValue={setAccountCode}

                                                />
                                            </RaikoGridFourColumn>

                                            <RaikoMultiSelectTable
                                                pageCount={pageCount}
                                                handleChangePagination={handleChangePage}
                                                tableData={usersList}
                                                tableHeader={header}
                                                setSelectedItems={setSelectedUser}
                                                selectedItems={selectedUser}
                                                isSingleSelect
                                                tableLoadingState={usersTableLoading}
                                                notSelectedAnyItemAlertTitle={"حساب مورد نظر خود را انتخاب نمایید"}
                                                notSelectedAnyItemAlertDescription={["برای یافتن آسان تر می توانید از فیلتر های بالا استفاده نمایید."]}
                                                selectedItemsTitle={"حساب انتخاب شده"}
                                                tableHintTitle={""}
                                            />

                                        </RaikoGridOneColumn> :
                                        stepper === 1 ?
                                            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                                                <RaikoCardInfoTypeOne
                                                    title={selectedUserInfo.name}
                                                    titleLabel={"مالک حساب"}
                                                    items={[
                                                        RaikoCardInfoTypeOneItemGenerator("شماره حساب", selectedUserInfo.accountCode),
                                                        RaikoCardInfoTypeOneItemGenerator("کد ملی", selectedUserInfo.nationalCode),
                                                        RaikoCardInfoTypeOneItemGenerator("گروه", selectedUserInfo.group),
                                                    ]}
                                                />

                                                <RaikoGridOneColumn>
                                                    <RaikoTableTitleContainer
                                                        title={"اطلاعات وام"}
                                                    />
                                                    <RaikoGridFourColumn>
                                                        <RaikoCustomSelect
                                                            labelText={"نوع وام"}
                                                            value={selectedLoanType}
                                                            setValue={setSelectedLoanType}
                                                            items={loanKinds}
                                                        />
                                                        <RaikoMoneyInputOutlined
                                                            labelText={"مبلغ وام (ریال)"}
                                                            value={loanAmount}
                                                            setValue={setLoanAmount}
                                                        />

                                                        <RaikoDatePicker
                                                            label={"تاریخ پرداخت"}
                                                            date={payDate}
                                                            setDate={setPayDate}/>

                                                        <RaikoMoneyInputOutlined
                                                            labelText={"تعداد اقساط"}
                                                            value={installmentAmounts}
                                                            setValue={setInstallmentAmounts}
                                                        />

                                                    </RaikoGridFourColumn>
                                                </RaikoGridOneColumn>

                                                <RaikoGridOneColumn>
                                                    <RaikoTableTitleContainer
                                                        title={"پیش نمایش اقساط"}
                                                        amount={installments.length}
                                                    />

                                                    {
                                                        installmentsLoading ?
                                                            [...Array(3)].map((item) => {
                                                                return <Skeleton
                                                                    key={item}
                                                                    variant="rectangular"
                                                                    className={css`padding: 100px 100px`}
                                                                />
                                                            })
                                                            : installments && installments.length > 0 ?
                                                                installments.map((item, index) => {
                                                                    return <RaikoCardInfoTypeOne
                                                                        title={convertUniversalDateTimeToPersianDateTime(item.date)}
                                                                        titleLabel={"سررسید"}
                                                                        items={[
                                                                            RaikoCardInfoTypeOneItemGenerator("مبلغ قسط (ریال)", convertCurrencyFormatPositiveNegative(item.amount)),
                                                                            RaikoCardInfoTypeOneItemGenerator("کارمزد (ریال)", convertCurrencyFormatPositiveNegative(item.amountOfCommission)),
                                                                            RaikoCardInfoTypeOneItemGenerator("مبلغ کمکی (ریال)", convertCurrencyFormatPositiveNegative(item.auxiliaryAmount)),
                                                                            RaikoCardInfoTypeOneItemGenerator("قابل پرداخت (ریال)", convertCurrencyFormatPositiveNegative(item.payableAmount)),
                                                                        ]}
                                                                    />
                                                                }) :
                                                                <RaikoErrorSection
                                                                    title={"برای نمایش اقساط ابتدا مشخصات فوق را وارد نمایید."}
                                                                />
                                                    }
                                                </RaikoGridOneColumn>
                                            </RaikoGridOneColumn> :
                                            <RaikoGridOneColumn>
                                                <RaikoCardInfoTypeOne
                                                    title={selectedUserInfo.name}
                                                    titleLabel={"مالک حساب"}
                                                    items={[
                                                        RaikoCardInfoTypeOneItemGenerator("شماره حساب", selectedUserInfo.accountCode),
                                                        RaikoCardInfoTypeOneItemGenerator("کد ملی", selectedUserInfo.nationalCode),
                                                        RaikoCardInfoTypeOneItemGenerator("گروه", selectedUserInfo.group),
                                                    ]}
                                                />
                                                <RaikoCardInfoTypeOne
                                                    title={convertCurrencyFormatPositiveNegative(filterLoanAmount)}
                                                    titleLabel={"مبلغ وام (ریال)"}
                                                    items={[
                                                        RaikoCardInfoTypeOneItemGenerator("نوع وام", detectLoanKindName(filterSelectedLoanType)),
                                                        RaikoCardInfoTypeOneItemGenerator("تاریخ پرداخت", filterLoanPayDate),
                                                        RaikoCardInfoTypeOneItemGenerator("تعداد اقساط", filterInstallmentAmounts),
                                                    ]}
                                                />

                                                <RaikoToggleOutlined
                                                    checked={submitPaidForAll}
                                                    setChecked={setSubmitPaidForAll}
                                                    labelText={"پرداخت یکجا تمامی اقساط هنگام ساخت وام"}
                                                />

                                                <RaikoFlexAlignEnd>
                                                    <RaikoButtonPrimary
                                                        label={"ثبت و افزودن وام"}
                                                        onClick={handleCreateNewLoan}
                                                    />
                                                </RaikoFlexAlignEnd>
                                            </RaikoGridOneColumn>
                                }
                            </RaikoGridOneColumn>
                        </div>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}

const header = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'name',
        label: 'نام',
        align: 'right',
    },
    {
        id: 'nationalCode',
        label: 'کد ملی',
        align: 'right',
    },
    {
        id: 'accountCode',
        label: 'شماره حساب',
        align: 'right',
    },
    {
        id: 'group',
        label: 'گروه',
        align: 'right',
    },
    {
        id: 'capacity',
        label: 'موجودی(ریال)',
        align: 'right',
    },
    {
        id: 'enabled',
        label: 'وضعیت',
        align: 'right',
    },
]
